"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.mergeItemCollections = void 0;
const uniqBy_1 = __importDefault(require("lodash/uniqBy"));
function mergeItemCollections(old, toAdd) {
    const itemsToAddById = toAdd.items.reduce((p, c) => (Object.assign(Object.assign({}, p), { [c.id]: c })), {});
    const items = (0, uniqBy_1.default)([...old.items.map(item => itemsToAddById[item.id] || item), ...toAdd.items], i => i.id);
    return {
        loading: toAdd.loading,
        lastLoaded: toAdd.lastLoaded,
        items,
        totalCount: Math.max(old.totalCount, toAdd.totalCount),
    };
}
exports.mergeItemCollections = mergeItemCollections;
exports.default = mergeItemCollections;
